import { Controller } from '@hotwired/stimulus';
import { MDCSwitch } from '@material/switch';

export default class extends Controller {
  static values = { hiddenInputId: String };

  get hiddenInput() {
    return document.getElementById(this.hiddenInputIdValue);
  }

  connect() {
    this.switch = new MDCSwitch(this.element);
    this.element.addEventListener('click', () => {
      this.handleToggle();
    });
  }

  disconnect() {
    if (this.switch) {
      this.switch.destroy();
    }
  }

  handleToggle() {
    this.hiddenInput.value = this.switch.selected ? '1' : '0';
  }
}
